import { object, string } from 'yup';

import { EMAIL, MESSAGE } from 'store/session';

export const validationSchema = object().shape({
  [EMAIL]: string().email('Email address is invalid').required('Email address is missing'),
  [MESSAGE]: string().required('Message is missing'),
});
